import { render, staticRenderFns } from "./Hotel.vue?vue&type=template&id=bb282b88&scoped=true"
import script from "./Hotel.vue?vue&type=script&lang=js"
export * from "./Hotel.vue?vue&type=script&lang=js"
import style0 from "./Hotel.vue?vue&type=style&index=0&id=bb282b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb282b88",
  null
  
)

export default component.exports